import { render } from "./PresentacionesView.vue?vue&type=template&id=59f0f54a&scoped=true"
import script from "./PresentacionesView.vue?vue&type=script&lang=js"
export * from "./PresentacionesView.vue?vue&type=script&lang=js"

import "./PresentacionesView.vue?vue&type=style&index=0&id=59f0f54a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59f0f54a"]])

export default __exports__